module.exports = __webpack_public_path__ + "static-portal/img/new4-4.1cf429b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new4-4.png
// module id = Cg7H
// module chunks = 4